<template>
  <div>
    <a-form layout="inline">
      <a-form-item label="关键字">
        <a-input
          v-model:value="form.keyword"
          placeholder="请输入礼品名称"
          style="width: 220px"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="
            form.page = 1;
            getGiftSkuList();
          "
          >搜索</a-button
        >
      </a-form-item>
    </a-form>
    <a-table
      class="m-t-20"
      :columns="columns"
      rowKey="gift_id"
      :loading="loading"
      :data-source="sku_list"
      bordered
      :pagination="pagination"
      @change="changePage"
    >
      <template v-slot:gift="{ record }">
        <div style="display: flex;align-items: center;">
          <img :src="info.picdomain + '/' + record.gift_image"
            style="
              width: 60px;
              height: 60px;
              border: 1px solid #eee;
              border-radius: 6px;
            "
          />
          <span class="m-l-10 s_omit2">{{ record.gift_name }}</span>
        </div>
      </template>
      <!--  -->
      <template v-slot:action="{ record }">
        <a-button
          type="primary"
          :ghost="!record.checked"
          @click="selectSku(record)"
          >{{ record.checked ? "已选择" : "选择" }}</a-button
        >
      </template>
    </a-table>
  </div>
</template>
<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { giftSkuList } from "@/api/guide";
import { iscode } from "../../../../utils/app";
import { message } from "ant-design-vue";
import store from "@/store";
const columns = [
  {
    title: "礼品名称",
    dataIndex: "gift_name",
    key: "gift_name",
    slots: { customRender: "gift" },
  },
  {
    title: "规格",
    dataIndex: "gift_sku_name",
    key: "gift_sku_name",
    width: 140,
  },
  {
    title: "价格/元",
    dataIndex: "gift_price",
    key: "gift_price",
    width: 120,
  },
  {
    title: "库存",
    dataIndex: "stock_num",
    key: "stock_num",
    width: 120,
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    slots: { customRender: "action" },
    width: 120,
  },
];
export default {
  props: {
    selecGift: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      loading: false,
      info: store.state.user.info,
      sku_list: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        defaultPageSize: 5,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "15", "20"],
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
    });
    const form = ref({
      keyword: "",
      page: 1,
      limit: 5,
    });
    const getGiftSkuList = async ()=> {
      state.loading = true;
      state.sku_list = [];
      let res = await giftSkuList({ ...form.value }).then((res) => res.data);
      state.loading = false;
      if (iscode(res)) {
        state.sku_list = res.data.data || [];
        state.pagination.current = res.data.current_page;
        state.pagination.total = res.data.total;
        console.log(props.selecGift[0], "2222");
        if (!props.selecGift[0]) return;

        for (let i = 0; i < state.sku_list.length; i++) {
          state.sku_list[i].checked = false;
          if (state.sku_list[i].gift_sku == props.selecGift[0].gift_sku) {
            state.sku_list[i].checked = true;
          }
        }
      } else {
        message.error(res.msg);
      }
    };

    const changePage = async function (e) {
      state.pagination.current = e.current;
      state.pagination.pageSize = e.pageSize;
      form.value.page = e.current;
      form.value.limit = e.pageSize;
      getGiftSkuList();
    };
    //
    const selectSku = function (data) {
      emit("selectSku", data);
    };

    onMounted(() => {
      getGiftSkuList();
    });
    return {
      form,
      ...toRefs(state),
      columns,
      changePage,
      selectSku,
      getGiftSkuList,
    };
  },
};
</script>
